'use client';

import { X } from 'lucide-react';
import styles from './DisclaimerModal.module.css';

interface DisclaimerModalProps {
  open: boolean;
  onClose: () => void;
  onAccept?: () => void;
}

export default function DisclaimerModal({ open, onClose, onAccept }: DisclaimerModalProps) {
  if (!open) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>

        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.title}>Disclaimer</h2>
          <button onClick={onClose} className={styles.close}>
            <X size={18} />
          </button>
        </div>

        {/* Content */}
        <div className={styles.content}>
          <strong>Genetic Risk Assessment</strong> is a research experiment using a
          general purpose artificial intelligence. It is designed to predict the risk
          of genetic diseases from the information provided by the user. The tool is not
          intended to replace professional medical advice, or support diagnosis,
          prevention, monitoring, prediction or treatment and should never be used to
          make diagnostic judgments for real patients. Because AI can give variable
          results, the risk prediction from the tool may vary, so it is important to
          consult a qualified healthcare professional to ensure an accurate and
          appropriate diagnosis. Use of this tool is at the user's own risk and
          Vgenomics is not responsible for any consequences or damages that may result
          from its use. By using this tool, the user acknowledges that he/she has read
          and understood this disclaimer and accepts any potential risks associated with
          the use of the artificial intelligence-based tool.
        </div>

        {/* Actions */}
        <div className={styles.actions}>
          <button
            onClick={() => {
              onAccept?.();
              onClose();
            }}
            className={styles.primaryButton}
          >
            I Agree
          </button>
        </div>

      </div>
    </div>
  );
}
